import {Injectable} from '@angular/core'

import {Store} from '../../models/store'
import { UserDto } from '../dto/user.dto'
import { DroitApplicatifCode } from '../../models/user'
import { DroitApplicatifDto } from '../dto/droit-applicatif.dto'
import { ChantierDto } from '../dto/chantier.dto'

export interface UserStateModel {
  connectedUser: UserDto
  userChantiers: ChantierDto[]
}

@Injectable({ providedIn: 'root' })
export class UserState {
  store = new Store<UserStateModel>({
    connectedUser: null,
    userChantiers: [],
  })

  static getConnectedUser = (state: UserStateModel): UserDto => state.connectedUser

  static userHasDroitApplicatif =
    (droitApplicatifCode: DroitApplicatifCode) =>
    (state: UserStateModel): boolean =>
      (state.connectedUser?.accesApplicatif ?? [])
        .flatMap((acces) => acces.droits)
        .map((droit) => droit.code)
        .includes(droitApplicatifCode)

  static userHasOneOfTheseDroitsApplicatifs =
    (droitsApplicatifsCodes: DroitApplicatifCode[]) =>
    (state: UserStateModel): boolean =>
      (state.connectedUser?.accesApplicatif ?? [])
        .flatMap((acces) => acces.droits)
        .map((droit) => droit.code)
        .some((userDroitCode: DroitApplicatifCode) => droitsApplicatifsCodes.includes(userDroitCode))

  static getDroitsApplicatifs = (state: UserStateModel): DroitApplicatifDto[] =>
    (state.connectedUser?.accesApplicatif ?? []).flatMap((acces) => acces.droits)

  static getUserChantiers = (state: UserStateModel): ChantierDto[] => state.userChantiers
}
